import { useEffect, useRef, useState } from "react"

export function useFocus() {
  const [focus, setFocus] = useState()
  const focusRef = useRef()

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (focusRef.current && !focusRef.current.contains(event.target)) {
        setFocus()
      }
    }
    document.addEventListener("click", handleClickOutside, true)

    return () => {
      document.removeEventListener("click", handleClickOutside, true)
    }
  }, [])

  return { focus, setFocus, focusRef }
}
